/**
 * Users/Index Controller
 *
 * 
 */

// the constructor for this object
function UsersIndexController() { }

// the object
UsersIndexController.prototype = {
    constructor: UsersIndexController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        PortalHelper.debugMessage('Users Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // can the user edit accounts
        if (this._userHasAdminAccounts()) {
            
            // enable the control buttons
            this._enableButtons();
            
            // get the users
            this._getUsersForTable();
        }
        
        PortalHelper.debugMessage('Users Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   

    },
    
    // Checks if the user has administrator access to any customer accounts. 
    _userHasAdminAccounts: function()
    {
        var portalUserAccountIds = PortalHelper.getAdminAccountIDs();
        /*
            Return if the user has no admin access to any customer accounts
        */
        if(portalUserAccountIds.length == 0) {
            $('.table-wrap').html('Your account does not have permission to edit users');
            PortalHelper.loadingOverlay('.table-wrap', false);
            return false;
        } 
        
        return true;
    },
    
    // enable the buttons
    _enableButtons: function()
    {
        PortalHelper.enableButton('#new-user-button');
        PortalHelper.enableButton('#add-existing-button');    
    },
    
    /*
        Retrieves a listing of all users of customer accounts the current user
        is associated with, and creates a table based on that list
    */    
    _getUsersForTable: function()
    {
        PortalHelper.loadingOverlay('.table-wrap', true);
    
        var userInfoRequest = new PortalRequest;
        var self = this;
        userInfoRequest.errorElement = '.form-errors';
        userInfoRequest.makeRequest(
            '/users/get-users',
            {},
            function(response) {
                self._populateTable(response);
            }
        )
    },
    
    /* 
        Adds a new row to the user listing, with links for editing and deleting
        the account
    */
    _populateTable: function(response)
    {
        for(var i in response) {
            var userAcct = response[i];
            if(!this._isMemberOfAdminAccount(userAcct)) {
                continue;
            }
            var newRow = $('tr.clone-source').clone();
            newRow.removeClass('hidden').removeClass('clone-source');
            newRow.find('.email-address').html(userAcct.email_nm);
            newRow.find('.first-name').html(userAcct.first_nm);
            newRow.find('.last-name').html(userAcct.last_nm);
            newRow.find('.edit-link').attr("href",
                PortalConfig.portalUrl +
                '/users/edit-user/' +
                userAcct.user_id
            );
            newRow.find('.delete-link').attr("href",
                PortalConfig.portalUrl +
                '/users/delete-user/' +
                userAcct.user_id
            );
            $('#account-list').append(newRow);
        }
        
        PortalHelper.loadingOverlay('.table-wrap', false);
    },
    
    /*
        Checks if a user account is a member of a customer account that the
        user has administator access to.
    */
    _isMemberOfAdminAccount: function(userAcct)
    {
        var adminIDs = PortalHelper.getAdminAccountIDs();
        var contains = false;
        var custAccountObjs = userAcct.accounts_users;
        for(var a in custAccountObjs){
            if(adminIDs.includes(custAccountObjs[a].account_id)) {
                contains = true;
            }
        }
        return contains;
    }
    
}